import { useTranslation } from "@refinedev/core";
import { IModalProps, Modal } from "components/modal";
import { Tag } from "components/tag";
import { IEventIdsItem, IPromotionConditionItem } from "interfaces";
import { get } from "lodash";
import { getApplyToProductTypeLabel, getDiscountTypeLabel } from "utills/helpers";

interface IConditionInfoModalProps extends IModalProps {
  conditionData: IPromotionConditionItem | null;
  events: IEventIdsItem[];
}

export const ConditionInfoModal = ({
  onClose,
  open,
  conditionData,
  events,
}: IConditionInfoModalProps) => {
  const { translate, getLocale } = useTranslation();
  return (
    <Modal title="Event List" onClose={onClose} open={open}>
      <div className="flex flex-col w-full gap-y-4 divide px-4 py-3.5 text-base sm:max-w-xl">
        <div className="relative flex items-start justify-between gap-x-6">
          <p className="flex-1 font-semibold leading-6">Condition Name</p>
          <p className="flex-1 text-right text-sm leading-6">
            {conditionData?.note}
          </p>
        </div>
        <div className="relative flex items-start justify-between gap-x-6">
          <p className="flex-1 font-semibold leading-6">Discount Type</p>
          <p className="flex-1 text-right text-sm leading-6">
            {getDiscountTypeLabel(conditionData?.discount_type)}
          </p>
        </div>
        <div className="relative flex flex-col gap-4">
          <div className="flex-1 font-semibold leading-6 flex flex-wrap items-center gap-x-2">
            Events{" "}
            <Tag
              text={getApplyToProductTypeLabel(
                conditionData?.apply_to_product_type
              )}
            />{" "}
          </div>
          <ol className="list-decimal pl-4 space-y-2.5 text-sm">
            {(conditionData?.event_ids ?? []).map((eventId) => (
              <li key={eventId}>
                {get(
                  events.find((event) => event.id === eventId),
                  `name_${getLocale()}`,
                  ""
                )}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </Modal>
  );
};
